/*
 * @Author: changcheng
 * @LastEditTime: 2023-11-10 13:21:16
 */
import "./_index.scss";
import guidHeader from "@root/img/guid_header.png";
import guideCentero1 from "@root/img/guidCenter01.png";
import guideCentero2 from "@root/img/guidCenter02.png";
import guideCentero3 from "@root/img/guidCenter03.png";
import guideCentero4 from "@root/img/guidCenter04.png";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { postLeaveAdvertisementTimeMap } from "@root/common/utils";
const data = [
  {
    img: guideCentero1,
    content: [
      {
        id: 179,
        name: "“千县工程”县医院肿瘤防治中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院慢病管理中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院微创介入中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院麻醉疼痛诊疗中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院重症监护中心指南",
      },
    ],
  },
  {
    img: guideCentero2,
    content: [
      {
        id: 0,
        name: "“千县工程”县医院胸痛中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院卒中中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院创伤中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院危重孕产妇救治中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院危重儿童和新生儿救治中心指南",
      },
    ],
  },
  {
    img: guideCentero3,
    content: [
      {
        id: 0,
        name: "“千县工程”县医院医学检验中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院医学影像中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院心电诊断中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院病理中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院消毒供应中心指南",
      },
    ],
  },
  {
    img: guideCentero4,
    content: [
      {
        id: 0,
        name: "“千县工程”县医院医疗质控中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院人力资源中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院运营管理中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院医保管理中心指南",
      },
      {
        id: 0,
        name: "“千县工程”县医院信息数据中心指南",
      },
    ],
  },
];
export default function GuideCenter() {
  const navigate = useNavigate();
  return (
    <div>
      <div className="guid_header">
        <img src={guidHeader} width={"100%"} alt="" />
        <p className="title">“千县工程”县域二十大中心指南发布</p>
      </div>
      <div className="guid_center_box">
        {data.map((item, index) => (
          <div className="child">
            <img src={item.img} alt="" />
            {item.content.map((it) => (
              <p
                onClick={() => {
                  const { id } = it;
                  if (id) {
                    navigate(`/news/details/${id}`);
                  } else {
                    message.info("敬请期待");
                  }
                }}
              >
                <span>{it.name}</span>
                <span>2023-10-25</span>
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
